import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CaptableGroupingMode } from '../SummaryGrid2/CaptableSummaryColDefs2';

interface IGroupingToggleProps {
  value: CaptableGroupingMode;
  onChange: (value: CaptableGroupingMode) => void;
}

export function GroupingToggle({ value, onChange }: IGroupingToggleProps) {
  return (
    <ToggleButtonGroup
      color='secondary'
      value={value}
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) {
          onChange(newValue);
        }
      }}
      aria-label='Group by'
    >
      <ToggleButton value={CaptableGroupingMode.stakeholder}>By Stakeholder</ToggleButton>
      <ToggleButton value={CaptableGroupingMode.shareClass}>By Share Class</ToggleButton>
    </ToggleButtonGroup>
  );
}
